import { lightSuccess, lightWarning } from 'src/colors';
import { AdminInvitationStatus } from '../types/enum/admin-invitation-status';

export const adminInvitationStateTranslations = {
  [AdminInvitationStatus.ACCEPTED]:
    'organizationDetails:admins.invitationStatuses.accepted' as const,
  [AdminInvitationStatus.PENDING]:
    'organizationDetails:admins.invitationStatuses.pending' as const,
};

export const adminInvitationStateColor = {
  [AdminInvitationStatus.PENDING]: lightWarning.light,
  [AdminInvitationStatus.ACCEPTED]: lightSuccess.dark,
};
